import React from 'react'
import BellIcon from "../../../../assets/svgs/BellIcon"
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import useMixpanel from '../../../../hooks/useMixpanel';


const Notification = () => {
    const { track } = useMixpanel();

    const handleNotificationClick = () => {
        try {
        track("Notification Clicked")
        } catch (err) {
            // Silently handle tracking errors to prevent app disruption
            console.warn('Notification tracking error:', err);
        }
    }

    return (
        <>
            <Tooltip title="Notifications">
                <IconButton color="inherit" onClick={handleNotificationClick}>
                    <SvgIcon>
                        <BellIcon/>
                    </SvgIcon>
                </IconButton>
            </Tooltip>
        </>
    )
}

export default Notification